<app-dialog [(visible)]="visible" (closed)="close()" [showCloseButton]="true" class="max-w-[60rem]" [fullscreenOnMobile]="true">
    <ng-template #headerTemplate>
        <div class="p-2">
            <h2 class="text-xl font-bold text-gray-900 m-0">Assign credits</h2>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="flex flex-col overflow-hidden" style="height: 70vh;">
            <!-- Subheader -->
            <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100 flex-shrink-0">
                <div class="flex items-center gap-3">
                    <app-avatar-stack [users]="checkoutUsers" size="sm" [visibleAvatars]="3" />
                    <span class="text-sm font-medium text-gray-700">Assign credits to selected team members</span>
                </div>
                <div class="flex items-center gap-1.5 px-3 py-1 bg-blue-50 rounded-full">
                    <span class="w-2 h-2 rounded-full bg-blue-500 flex-shrink-0"></span>
                    <span class="text-sm text-blue-600 font-medium">
                        {{ checkoutItems.length }} {{ checkoutItems.length === 1 ? 'user' : 'users' }} selected
                    </span>
                </div>
            </div>
            <!-- Search -->
            <div class="py-3 flex-shrink-0">
                <app-search-bar placeholder="Search users..." [(ngModel)]="searchQuery" width="100%"></app-search-bar>
            </div>
            <!-- Table -->
            <div class="flex-1 overflow-y-auto min-h-0">
                <app-data-table [data]="filteredCheckoutItems" [columns]="checkoutTableColumns" [config]="checkoutTableConfig"
                    [dataKey]="'requestId'" [customTemplates]="checkoutTemplatesMap">
                </app-data-table>
            </div>
            <!-- Order Summary -->
            <div
                class="border rounded-base border-gray-200 bg-gray-50 px-6 py-4 flex items-start justify-between gap-8 flex-shrink-0">
                <div class="flex flex-col gap-1.5">
                    <span class="text-sm font-bold text-gray-800">Order summary</span>
                    <div class="text-sm text-gray-500">Total requested credits
                        <span class="font-semibold text-gray-900 ml-1">{{ getTotalCredits() }} credits</span>
                    </div>
                    <div class="text-sm text-gray-500">Number of users
                        <span class="font-semibold text-gray-900 ml-1">{{ checkoutItems.length }}
                            {{ checkoutItems.length === 1 ? 'member' : 'members' }}</span>
                    </div>
                </div>
                <div class="flex flex-col items-end gap-1">
                    <ng-container *ngIf="!isSalesMode">
                        <span class="text-xs text-gray-500">Total amount</span>
                        <span class="text-3xl font-bold text-gray-900">${{ checkoutGrandTotal | number:'1.2-2' }}</span>
                        <span class="text-xs text-gray-400">+ applicable taxes</span>
                    </ng-container>
                    <app-button [label]="isSalesMode ? 'Add Credits' : 'Proceed with Payment'" variant="filled"
                        severity="primary" [icon]="'arrow-right'" [iconSource]="'lucide'" iconPosition="right"
                        (clicked)="confirmCheckout()" class="mt-1"
                        [disabled]="isSalesMode ? getTotalCredits() === 0 : checkoutGrandTotal === 0" />
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex items-center justify-end w-full">
            <app-button label="Cancel" variant="outlined" severity="contrast" [size]="'sm'" (clicked)="close()" />
        </div>
    </ng-template>
</app-dialog>

<!-- Table cell templates -->
<ng-template #checkoutUserTemplateRef let-item="$implicit">
    <div class="flex items-center gap-3 py-1">
        <img [src]="item.request.requestedBy | userAvatar" class="rounded-full w-8 h-8 object-cover" alt="" />
        <div class="flex flex-col">
            <span class="text-sm font-semibold text-gray-900">{{ item.request.name }}</span>
            <span class="text-xs text-gray-500">{{ item.request.email }}</span>
        </div>
    </div>
</ng-template>

<ng-template #checkoutAskBalanceTemplateRef let-item="$implicit">
    <span class="text-sm font-medium text-gray-900">
        {{ userBalances.get(getUserId(item))?.ask ?? '—' }}
    </span>
</ng-template>

<ng-template #checkoutAgentBalanceTemplateRef let-item="$implicit">
    <span class="text-sm font-medium text-gray-900">
        {{ userBalances.get(getUserId(item))?.agent ?? '—' }}
    </span>
</ng-template>

<ng-template #checkoutAskTemplateRef let-item="$implicit">
    <div class="flex items-center gap-2">
        <app-button (clicked)="decrement(item, 'askCredits')" variant="outlined" severity="contrast"
            [icon]="'minus'" [iconSource]="'lucide'" [size]="'sm'" [disabled]="item.askCredits <= 0" />
        <app-input type="number" [ngModel]="item.askCredits"
            (ngModelChange)="onCreditsChange(item, 'askCredits', $event)"
            [min]="0" size="sm" class="text-center">
        </app-input>
        <app-button (clicked)="increment(item, 'askCredits')" variant="outlined" severity="contrast"
            [icon]="'plus'" [iconSource]="'lucide'" [size]="'sm'"
            [disabled]="checkoutGrandTotal >= MAX_TOTAL" />
    </div>
</ng-template>

<ng-template #checkoutAgentTemplateRef let-item="$implicit">
    <div class="flex items-center gap-2">
        <app-button (clicked)="decrement(item, 'agentCredits')" variant="outlined" severity="contrast"
            [icon]="'minus'" [iconSource]="'lucide'" [size]="'sm'" [disabled]="item.agentCredits <= 0" />
        <app-input type="number" [ngModel]="item.agentCredits"
            (ngModelChange)="onCreditsChange(item, 'agentCredits', $event)"
            [min]="0" size="sm" class="text-center">
        </app-input>
        <app-button (clicked)="increment(item, 'agentCredits')" variant="outlined" severity="contrast"
            [icon]="'plus'" [iconSource]="'lucide'" [size]="'sm'"
            [disabled]="checkoutGrandTotal >= MAX_TOTAL" />
    </div>
</ng-template>
